import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const legacyLineagePlugin = createPlugin({
  id: 'legacy-lineage',
  routes: {
    root: rootRouteRef,
  },
});

export const LegacyLineagePage = legacyLineagePlugin.provide(
  createRoutableExtension({
    name: 'LegacyLineagePage',
    component: () => import('./components/LegacyLineage/LineageDisplay').then(m => m.LineageDisplay),
    mountPoint: rootRouteRef,
  }),
);
